import React from "react";

import BaseApp from "@apps/base/BaseApp";
import {createRoot} from "react-dom/client";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";

import {setConsumerHeader} from "@globals/utils/setConsumerHeader";

import {AccessRightFlags, CheckAccess} from "@components/CheckAccess";

import DailyMenuApp from "./DailyMenuApp";

setConsumerHeader();

const root = createRoot(document.getElementById("root")!);

root.render(
  <BaseApp includeHeader={false}>
    <BrowserRouter basename="/menu">
      <CheckAccess
        flag={AccessRightFlags.Authorized}
        redirectTo={"/login/"}
        saveUrl={true}
      >
        <Routes>
          <Route path="/" element={<DailyMenuApp />} />
          {/* keep this route for backward compatibility */}
          <Route path=":menuDay" element={<DailyMenuApp />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </CheckAccess>
    </BrowserRouter>
  </BaseApp>
);
